import { render, staticRenderFns } from "./uploadhead.vue?vue&type=template&id=0547730e&scoped=true&"
import script from "./uploadhead.vue?vue&type=script&lang=js&"
export * from "./uploadhead.vue?vue&type=script&lang=js&"
import style0 from "./uploadhead.vue?vue&type=style&index=0&id=0547730e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0547730e",
  null
  
)

export default component.exports